import { Attachments } from "../../components/ProductDetailSheet";
import ProductDetailSheetLoader from "../../components/ProductDetailSheetLoader";
import { useProductDetailContext } from "../context/ProductDetailContext";

import Avatar from "@/components/reusables/Avatar";
import FetchWrapper from "@/components/reusables/FetchWrapper";
import { H3 } from "@/components/reusables/typography";
import EmptyData from "@/components/state-pages/EmptyData";
import * as Sheet from "@/components/ui/sheet";
import { ToolsConstants, ToolsKeys } from "@/constants/tools.constant";
import useQueryID from "@/hooks/useQueryId";
import { useGetSingleSubProductQuery } from "@/redux/api/toolsQuery";

interface SubProductDetailSheetProps {
  isOpen: boolean;
  toggleSubProductDetailSheet: () => void;
}
const SubProductDetailSheet = ({
  isOpen,
  toggleSubProductDetailSheet,
}: SubProductDetailSheetProps): JSX.Element => {
  const { productId } = useProductDetailContext();
  const { id, reset } = useQueryID(ToolsKeys.SUB_PRODUCT_ID);
  const { data, ...rest } = useGetSingleSubProductQuery({
    id: productId,
    subProductId: id,
  });
  const productData = data?.data;
  const handleExit = (): void => {
    reset();
    toggleSubProductDetailSheet();
  };

  return (
    <Sheet.Sheet open={isOpen} onOpenChange={handleExit}>
      <Sheet.SheetContent className='min-w-[38dvw] min-h-screen overflow-scroll'>
        <FetchWrapper {...rest} loaderComp={<ProductDetailSheetLoader />}>
          <section className='space-y-5'>
            <section className=' border border-input p-4 rounded-md space-y-[14px]'>
              <div className='flex items-center gap-4'>
                <Avatar
                  src={productData?.images[0]}
                  name={productData?.name || ""}
                  className='!w-16 !h-16 '
                />
                <div>
                  <h1 className='text-xl font-semibold'>{productData?.name}</h1>
                  <p className='text-sm text-gray-400 font-bold'>
                    Model: {productData?.modelNumber || "--"}
                  </p>
                </div>
              </div>
            </section>
            <section className='space-y-2'>
              <H3>{ToolsConstants.PRODUCTS.FILES_AND_ATTACHMENTS}</H3>
              {productData?.images.length || productData?.files.length ? (
                <Attachments
                  filesAndImages={[
                    ...(productData?.images || []),
                    ...(productData?.files || []),
                  ]}
                />
              ) : (
                <EmptyData title='Files or attachments' />
              )}
            </section>
          </section>
        </FetchWrapper>
      </Sheet.SheetContent>
    </Sheet.Sheet>
  );
};

export default SubProductDetailSheet;
